// @flow strict

import { Alert, Card } from 'antd';
import * as React from 'react';
import RevenueGraph from './RevenueGraph';

function RevenueStats({ balanceData, isLoading }) {
  
  return (
    <div>
      <Card title={<h5>Revenue Data</h5>}>
        {
          balanceData?.balanceInfo &&
          <div className="d-flex gap-3">
            <Alert
              message={<h5>Available Balance</h5>}
              description={<h3>{'$' + balanceData?.balanceInfo?.balance}</h3>}
              type="success"
              className="w-100 h-100 text-center"
            />
            <Alert
              message={<h5>Pending Balance</h5>}
              description={<h3>{'$' + balanceData?.balanceInfo?.pending}</h3>}
              type="success"
              className="w-100 h-100 text-center"
            />
          </div>
        }
        {
          Object.keys(balanceData).length > 0 &&
          <div className="d-flex gap-3 mt-3">
            <Alert
              message={<h5>Today</h5>}
              description={<h3>{'$' + balanceData?.revenueToday}</h3>}
              type="info"
              className="w-100 h-100 text-center"
            />
            <Alert
              message={<h5>This Month</h5>}
              description={<h3>{'$' + balanceData?.revenueThisMonth}</h3>}
              type="info"
              className="w-100 h-100 text-center"
            />
            <Alert
              message={<h5>This Year</h5>}
              description={<h3>{'$' + balanceData?.revenueThisYear}</h3>}
              type="info"
              className="w-100 h-100 text-center"
            />
          </div>
        }
      </Card>
      <div className="mt-4">
        {
          Object.keys(balanceData).length > 0 &&
          <RevenueGraph isLoading={isLoading} balanceData={balanceData} />
        }
      </div>
    </div>
  );
};

export default RevenueStats;